import React, { FC } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { KB_LIST_URL, KB_NEW_URL, KB_EDIT_URL, KB_VIEW_URL } from 'constants/routes'
import { usePermission } from 'hooks/usePermission'
import { KB_MANAGE_PERM } from 'constants/permissions'
import KnowledgeBaseMain from 'pages/KnowledgeBaseMain'
import KnowledgeBaseView from 'pages/KnowledgeBaseView'
import KnowledgeBaseCreate from 'pages/KnowledgeBaseCreate'
import KnowledgeBaseEdit from 'pages/KnowledgeBaseEdit'

const KnowledgeBaseContainer: FC = () => {
  const { hasPermission } = usePermission()
  const canManage = hasPermission(KB_MANAGE_PERM)

  return (
    <Switch>
      <Route path={KB_LIST_URL} exact component={KnowledgeBaseMain} />
      {canManage && <Route path={KB_NEW_URL} exact component={KnowledgeBaseCreate} />}
      {canManage && <Route path={KB_EDIT_URL} exact component={KnowledgeBaseEdit} />}
      <Route path={KB_VIEW_URL} exact component={KnowledgeBaseView} />
      <Redirect to={KB_LIST_URL} />
    </Switch>
  )
}

export default KnowledgeBaseContainer
